/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_revcomp_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ambiguity codes: R (A/G) complements to Y (C/T).`)
};

const es_revcomp_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Códigos de ambigüedad: R (A/G) se complementa a Y (C/T).`)
};

const de_revcomp_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mehrdeutigkeitscodes: R (A/G) wird zu Y (C/T) komplementiert.`)
};

const nl_revcomp_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ambiguïteitscodes: R (A/G) complementeert naar Y (C/T).`)
};

const fr_revcomp_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codes d'ambiguïté : R (A/G) se complémente en Y (C/T).`)
};

const it_revcomp_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codici di ambiguità: R (A/G) si complementa a Y (C/T).`)
};

const pt_br2_revcomp_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Códigos de ambiguidade: R (A/G) tem como complemento Y (C/T).`)
};

const pt_revcomp_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Códigos de ambiguidade: R (A/G) complementa para Y (C/T).`)
};

const ja_revcomp_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`縮重コード: R (A/G) はY (C/T) に相補化されます。`)
};

const zh_revcomp_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`简并码：R（A/G）互补为 Y（C/T）。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const revcomp_ex3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.revcomp_ex3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("revcomp_ex3", locale)
	if (locale === "en") return en_revcomp_ex3(inputs)
	if (locale === "es") return es_revcomp_ex3(inputs)
	if (locale === "de") return de_revcomp_ex3(inputs)
	if (locale === "nl") return nl_revcomp_ex3(inputs)
	if (locale === "fr") return fr_revcomp_ex3(inputs)
	if (locale === "it") return it_revcomp_ex3(inputs)
	if (locale === "pt-BR") return pt_br2_revcomp_ex3(inputs)
	if (locale === "pt") return pt_revcomp_ex3(inputs)
	if (locale === "ja") return ja_revcomp_ex3(inputs)
	return zh_revcomp_ex3(inputs)
};